module.exports = __webpack_public_path__ + "static/media/singlePages.614eafcf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Editor/components/Result/images/singlePages.svg
// module id = 859
// module chunks = 0